module.exports = __webpack_public_path__ + "static/media/IconTemplates_-50.4a265fee.svg";